"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.json.stringify.js");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const WinterCheckout = props => {
  const [openModal, setOpenModal] = (0, _react.useState)(false);
  const [projectUrl, setProjectUrl] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    setOpenModal(props.showModal);
  }, [props.showModal]);
  (0, _react.useEffect)(() => {
    let queryString = 'projectId=' + props.projectId;

    if (props.walletAddress != null) {
      queryString += '&walletAddress=' + props.walletAddress;
    }

    if (props.email != null) {
      queryString += '&email=' + props.email;
    }

    if (props.mintQuantity != null) {
      queryString += '&mintQuantity=' + props.mintQuantity;
    }

    if (props.erc1155Video != null) {
      queryString += '&erc1155Video=' + props.erc1155Video;
    }

    if (props.title != null) {
      queryString += '&title=' + props.title;
    }

    if (props.extraMintParams != null) {
      queryString += "&extraMintParams=".concat(encodeURIComponent(JSON.stringify(props.extraMintParams)));
    }

    if (props.priceFunctionParams != null) {
      queryString += "&priceFunctionParams=".concat(encodeURIComponent(JSON.stringify(props.priceFunctionParams)));
    }

    const url = props.production ? 'https://checkout.usewinter.com/?' + queryString : 'https://sandbox-winter-checkout.onrender.com/?' + queryString;
    setProjectUrl(url);
  }, [props.projectId, props.production, props.walletAddress, props.email, props.mintQuantity, props.extraMintParams, props.priceFunctionParams, props.title, props.erc1155Video]);

  if (typeof window !== 'undefined') {
    window.addEventListener('message', event => {
      if (event.data == 'closeWinterCheckoutModal') {
        setOpenModal(false);
      }
    });
  }

  return openModal ? /*#__PURE__*/_react.default.createElement("iframe", {
    id: "winter-checkout",
    src: projectUrl,
    style: {
      position: 'fixed',
      top: '0px',
      bottom: '0px',
      right: '0px',
      width: '100%',
      border: 'none',
      margin: 0,
      padding: 0,
      overflow: 'hidden',
      zIndex: 999999,
      height: '100%'
    }
  }, " ") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

var _default = WinterCheckout;
exports.default = _default;